import { getCommonParamsItemLabel } from '@/utils/common'
import store from '@/store'

export const contentTableConfig = {
  // title: '('common.app-application-list')',
  title: '',
  propList: [
    {
      prop: 'name',
      label: 'file.application-name'
    },
    {
      prop: 'author',
      label: 'file.author',
      width: 180
    },
    {
      prop: 'company',
      label: 'file.company',
      width: 180
    },
    {
      prop: 'downloadCount',
      label: 'file.download-counts',
      width: 150
    },
    {
      prop: 'appType',
      label: 'file.application-type',
      formatter: (row) => {
        return getCommonParamsItemLabel(row, 'app_type')
      }
    },
    {
      prop: 'tenantId',
      label: 'user.tenant',
      width: 180,
      formatter: (row) => {
        return row ? store.getters.tenantDataMap[row] : ''
      }
    },
    {
      prop: 'status',
      width: 120,
      label: 'general.status',
      formatter: (row) => {
        return getCommonParamsItemLabel(row, 'status')
      }
    },
    {
      prop: 'createdTime',
      slotName: 'formatZeroTime',
      label: 'common.app-creation-time',
      width: 180
    },
    {
      prop: 'options',
      label: 'common.app-operation',
      width: 480,
      slotName: 'handler'
    }
  ],
  showIndexColumn: true
}
